import React from 'react';

export const GehaLogoTitle = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="134"
      height="38"
      viewBox="0 0 134 38"
      fill="none"
      {...props}
    >
      <title>GEHA</title>
      <path
        d="M120.308 1.65799L133.62 36.342H127.12L123.792 27.138H110.116L106.684 36.342H100.392L113.808 1.65799H120.308ZM122.232 22.51L119.372 14.762C118.124 11.33 117.708 9.97799 116.98 7.48199C116.356 9.66599 115.992 10.654 114.536 14.658L111.676 22.51H122.232Z"
        fill="#500778"
      />
      <path
        d="M97.0775 1.65799V36.342H90.9935V20.742H75.1335V36.342H69.0495V1.65799H75.1335V15.542H90.9935V1.65799H97.0775Z"
        fill="#500778"
      />
      <path
        d="M63.3872 1.65799V6.85799H44.4592V16.01H61.9832V20.95H44.4592V31.142H63.6992V36.342H38.3752V1.65799H63.3872Z"
        fill="#500778"
      />
      <path
        d="M32.084 17.882V36.342H28.184L27.248 32.234C24.492 35.614 21.06 37.174 16.484 37.174C6.656 37.174 0 29.894 0 19.286C0 8.31399 6.864 0.825989 17.004 0.825989C24.96 0.825989 30.992 5.66199 31.668 12.682H25.74C25.012 8.52199 21.632 5.97399 16.9 5.97399C10.192 5.97399 6.084 11.018 6.084 19.234C6.084 27.242 10.192 32.078 17.108 32.078C20.904 32.078 23.764 30.518 25.428 27.502C26.156 26.098 26.468 24.798 26.572 22.51H17.212V17.882H32.084Z"
        fill="#500778"
      />
    </svg>
  );
};
